const constants = {
    productName: 'API Spreadsheets',
    extensions: ['.xlsx', '.xls', '.csv', '.txt',  '.xlt', '.xlm', '.xlsm', '.xltx', '.xltm'],
    ItemTypes: {
        FileSummary: 'fileSummary'
    }
};

export default constants